import { ARMY_HARD_CAP, getEffectiveMultiplier } from '../../utils/constants';
import { Rng, randomInt } from './deterministic';

export type AddOrSubOperation =
  | { kind: 'add'; value: number }
  | { kind: 'sub'; value: number };

export type GateOperationLike =
  | { kind: 'mul'; value: number }
  | AddOrSubOperation;

const ADDITIVE_CHANCE = 0.8;

function getAddBand(level: number): [number, number] {
  if (level <= 2) return [3, 4];
  if (level <= 4) return [4, 6];
  if (level <= 6) return [6, 8];
  if (level <= 8) return [8, 10];
  return [10, 12];
}

function getSubBand(level: number): [number, number] {
  if (level <= 2) return [1, 2];
  if (level <= 4) return [2, 3];
  if (level <= 6) return [2, 4];
  if (level <= 8) return [3, 5];
  return [4, 6];
}

export function randomAddOperation(level: number, rng: Rng): AddOrSubOperation {
  const [min, max] = getAddBand(level);
  return { kind: 'add', value: randomInt(rng, min, max) };
}

export function randomSubOperation(level: number, rng: Rng): AddOrSubOperation {
  const [min, max] = getSubBand(level);
  return { kind: 'sub', value: randomInt(rng, min, max) };
}

export function randomAddOrSubOperation(level: number, rng: Rng): AddOrSubOperation {
  return rng.next() < ADDITIVE_CHANCE
    ? randomAddOperation(level, rng)
    : randomSubOperation(level, rng);
}

export function applyGateOperation(currentArmy: number, operation: GateOperationLike): number {
  if (operation.kind === 'mul') {
    return getEffectiveMultiplier(currentArmy, operation.value);
  }
  if (operation.kind === 'add') {
    return Math.min(ARMY_HARD_CAP, currentArmy + operation.value);
  }
  return Math.max(0, currentArmy - operation.value);
}
